export const CHANNEL_VISIBILITY_TYPES = Object.freeze({
  PRIVATE: "private",
  HIDDEN: "hidden",
});